import { render, staticRenderFns } from "./staffSet.vue?vue&type=template&id=4c9c160c&scoped=true&"
import script from "./staffSet.vue?vue&type=script&lang=js&"
export * from "./staffSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9c160c",
  null
  
)

export default component.exports